import React from 'react';
import { ChatBubbleLeftIcon
, EnvelopeOpenIcon
, UserPlusIcon  } from '@heroicons/react/24/solid';

// Example Data
const activities = [
    { id: 1, type: 'New Lead', description: 'John Doe submitted enquiry for "Product A".', time: '2 hours ago', icon: <UserPlusIcon  />, modifier: 'lead' },
    { id: 2, type: 'Email Opened', description: 'Campaign email "Q3 Offer" opened by Acme Corp.', time: '5 hours ago', icon: <EnvelopeOpenIcon
 />, modifier: 'email' },
    { id: 3, type: 'Note Added', description: 'Added note to Jane Smith\'s contact record.', time: '1 day ago', icon: <ChatBubbleLeftIcon
 />, modifier: 'note' },
    { id: 4, type: 'New Lead', description: 'Sarah Connor submitted enquiry for "Service B".', time: '2 days ago', icon: <UserPlusIcon  />, modifier: 'lead' },
];

const RecentActivity = () => {
    return (
        <div className="recent-activity-card"> {/* Use card-base styles via CSS */}
            <h3 className="recent-activity-card__title">Recent Activity</h3>
            <ul className="recent-activity-card__list">
                {activities.map((activity) => (
                    <li key={activity.id} className="recent-activity-card__item">
                        <div className={`recent-activity-card__icon-wrapper recent-activity-card__icon-wrapper--${activity.modifier}`}>
                           {/* Icon size/color handled by CSS */}
                           {activity.icon}
                        </div>
                        <div className="recent-activity-card__content">
                            <div className="recent-activity-card__header">
                                <h4 className="recent-activity-card__type">{activity.type}</h4>
                                <p className="recent-activity-card__time">{activity.time}</p>
                            </div>
                            <p className="recent-activity-card__description">{activity.description}</p>
                        </div>
                    </li>
                ))}
            </ul>
            <div className="recent-activity-card__view-all">
                <button>
                    View All Activity →
                </button>
            </div>
        </div>
    );
};

export default RecentActivity;